import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isSuperAdminOnlyPath, hasSuperAdmin } from './roleAccess'

export const Protected = ({ isLoggedIn, children }) => {
  const location = useLocation()
  const roles = useSelector(state => state.auth?.userinfo?.responseData?.roles)
  //TODO: below clear interval need to place on some other appropriate place where all pages can be used
  //or alternatively, approach need to change in AnalysingAssetEditPage.js where interval created
  clearInterval(localStorage.getItem('handleIntervalSubscription'))
  localStorage.removeItem('handleIntervalSubscription')

  clearInterval(localStorage.getItem('handleTemplate'))
  localStorage.removeItem('handleTemplate')

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ path: location.pathname }} />
  }

  // VAPT W1 — block non-SUPER_ADMIN users from admin-only views (defense-in-depth; the admin-2.0
  // backend enforces the same RBAC server-side). The route tree only mounts after the profile load
  // completes, so `roles` is populated here for logged-in users.
  if (isSuperAdminOnlyPath(location.pathname) && !hasSuperAdmin(roles)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}
